export function NovaAiSection() {
  return (
    <section id="nova-ai" aria-labelledby="ai-title" className="bg-white">
      <div className="inner split-grid">
        <div className="reveal">
          <img
            src="/assets/images/logo-nova-ai.png"
            alt="Nova AI"
            width="955"
            height="208"
            className="mb-8 h-12 w-auto"
            loading="lazy"
          />
          <h2 id="ai-title" className="heading-2">
            화면을 이해하는
            <br />
            <span className="text-brand-600">프라이빗 어시스턴트</span>
          </h2>
        </div>

        <figure className="reveal relative m-0 aspect-[670/392] w-full max-w-[670px]">
          <img
            src="/assets/images/nova-ai-panel-2.png"
            alt="Nova AI가 연동된 타임라인 분석 화면"
            width="2440"
            height="1408"
            className="absolute top-0 left-[8.955%] h-[89.796%] w-[91.045%] rounded-lg shadow-2xl"
            loading="lazy"
          />
          <img
            src="/assets/images/nova-ai-panel-1.png"
            alt="Nova AI 어시스턴트 대화 패널"
            width="1976"
            height="1420"
            className="absolute bottom-0 left-0 h-[90.561%] w-[73.731%]"
            loading="lazy"
          />
        </figure>
      </div>
    </section>
  );
}
